import styled from 'styled-components';

import { media } from '@/utils';

interface LayoutWrapperProps {
    $isMenuOpen?: boolean;
    $chatOpen?: boolean;
}

/* Szerokość dokowanego asystenta AI „Stefan" — musi zgadzać się z DOCK_WIDTH
   w DockedHelpAiChat. Gdy dok jest otwarty, wpychamy ramę aplikacji w lewo o tę
   wartość (tylko desktop — na tablecie/telefonie panel jest overlayem). */
const CHAT_DOCK_WIDTH = 400;

export const LayoutWrapper = styled.section<LayoutWrapperProps>`
    min-height: 100vh;
    height: 100%;
    display: grid;
    overflow: auto;
    grid-template-columns: auto auto 1fr;
    grid-template-rows: auto auto 2fr;
    /* Rama aplikacji (sidebar + topbar) jest biała; dzięki temu zaokrąglony
       lewy górny róg obszaru treści odsłania biały „notch". */
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    transition: padding-right 0.32s cubic-bezier(0.32, 0.72, 0, 1);

    ${media.desktop} {
        padding-right: ${({ $chatOpen }) => ($chatOpen ? `${CHAT_DOCK_WIDTH}px` : '0')};
    }

    ${media.tabletDown} {
        grid-template-columns: 1fr;
    }

    ${media.mobile} {
        height: auto;
        min-height: 100vh;
        overflow: visible;
    }

    ${({ $isMenuOpen }) => $isMenuOpen
            && `
                &:before {
                  content: '';
                  position: fixed;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background-color: rgba(0, 0, 0, 0.5);
                  z-index: 10;
                  backdrop-filter: blur(4px);
                }
              `}

   
    
`;

export const MainHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 68px;
    padding: 0 20px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};

    ${media.tablet} {
        height: 60px;
    }

    ${media.mobile} {
        height: 52px;
        padding: 0 12px;
    }
`;

export const Main = styled.div<{ $chatOpen?: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    /* Gdy dokowany asystent AI „Stefan" jest otwarty — blokujemy przewijanie
       treści i chowamy scrollbar (użytkownik skupia się na rozmowie). */
    overflow: ${({ $chatOpen }) => ($chatOpen ? 'hidden' : 'auto')};
    /* Obszar treści na jasnoszarym tle, wpuszczony w białą ramę aplikacji
       zaokrąglonym lewym górnym rogiem. */
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#0f1419' : '#f7f7f7')};
    border-top-left-radius: 16px;
    grid-column-start: 2;
    grid-column-end: -1;
    grid-row-start: 2;
    grid-row-end: -1;
    position: relative;

    ${media.tabletDown} {
        grid-column-start: 1;
        border-top-left-radius: 0;
    }

    ${media.mobile} {
        overflow: visible;
        padding-top: 52px;
        padding-bottom: 40px;
    }
`;

export const PageHeadline = styled.div`
    grid-column: 2 / -1;
    backdrop-filter: blur(12px);

    ${media.tabletDown} {
        grid-column: 1 / -1;
    }

    ${media.mobile} {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background: ${({ theme }) => theme.colors.topbar.background};
    }
`;
